// @flow
import React from 'react';
import Overlay from '@waglabs/overlay';
import Flex from '@waglabs/flex';
import Box from '@waglabs/box';

import { Container } from './components/Container';
import { Navigation } from '../Navigation';
import { Footer } from '../Footer';
import MobileNavigation from '../Navigation/components/MobileNavigation';
import AppInstallBannerContainer from '../../containers/AppInstallBannerContainer';
import { AppInstallBannerContext } from '../AppInstallBanner';

type Props = {
  children: any,
  currentPathname: string,
  currentUrl: string,
  disableFooter?: boolean,
  disableNavbar?: boolean,
};

type State = {
  isMobileMenuVisible: boolean,
};

class NavigationPage extends React.Component<Props, State> {
  state = {
    isMobileMenuVisible: false,
  };

  static defaultProps = {
    disableFooter: false,
    disableNavbar: false,
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.closeMobileMenu);
    }
  }

  closeMobileMenu = () => {
    if (window.innerWidth > 640) {
      this.setState({
        isMobileMenuVisible: false,
      });
    }
  }

  toggleMobileMenu = () => {
    this.setState(prevState => ({
      isMobileMenuVisible: !prevState.isMobileMenuVisible,
    }));
  }

  render() {
    const {
      children,
      currentPathname,
      currentUrl,
      disableFooter,
      disableNavbar,
    } = this.props;

    const {
      isMobileMenuVisible,
    } = this.state;

    return (
      <AppInstallBannerContext.Consumer>
        {({
          marginTop,
        }) => (
          <Container
            isMobileMenuVisible={isMobileMenuVisible}
          >
            <Box
              left="0"
              position={['fixed', 'relative']}
              width={1}
              zIndex={999}
            >
              <Flex
                alignItems="flex-start"
                flexDirection="column"
                width={1}
              >
                <AppInstallBannerContainer />

                {!disableNavbar
                && (
                <Navigation
                  currentPathname={currentPathname}
                  currentUrl={currentUrl}
                  isMobileMenuVisible={isMobileMenuVisible}
                  onClick={this.toggleMobileMenu}
                />
                )}
              </Flex>
            </Box>
            <Flex
              flexDirection="column"
              mt={[50 + marginTop, 0, 0, 0]}
              width={1}
            >
              {children}
            </Flex>
            {isMobileMenuVisible
            && (
              <Overlay />
            )}

            {!disableNavbar
            && (
            <MobileNavigation
              height={`calc(100vh - ${50 + marginTop}px)`}
              isMobileMenuVisible={isMobileMenuVisible}
              top={50 + marginTop}
            />
            )}

            {!disableFooter
              && (
              <Footer />
              )}
          </Container>
        )}
      </AppInstallBannerContext.Consumer>
    );
  }
}

export default NavigationPage;
